// Throttling mechanism to prevent multiple rapid notifications
let lastPlayTime = 0;
const NOTIFICATION_THROTTLE_MS = 1000; // 1 second minimum between notifications
let currentAudio = null;

const notificationAudioContext = require.context(
  "../assets/sounds/notification",
  false,
  /\.mp3$/,
);

const notificationAudioByName = notificationAudioContext
  .keys()
  .reduce((audioByName, key) => {
    const audioModule = notificationAudioContext(key);
    audioByName[key.replace("./", "")] =
      audioModule.default || audioModule;
    return audioByName;
  }, {});

const defaultNotificationSound = `${process.env.PUBLIC_URL || ""}/notification.mp3`;

const resolveNotificationAudioSource = (filePath) => {
  if (typeof filePath !== "string" || !filePath.trim()) {
    return defaultNotificationSound;
  }

  const trimmedPath = filePath.trim();
  if (/^(https?:|blob:|data:)/i.test(trimmedPath)) {
    return trimmedPath;
  }
  if (trimmedPath.startsWith("/")) {
    return trimmedPath;
  }

  const fileName = trimmedPath.split(/[?#]/)[0].split("/").pop();
  return notificationAudioByName[fileName] || defaultNotificationSound;
};

const createNotificationAudio = (filePath) => {
  const audio = new Audio(resolveNotificationAudioSource(filePath));
  audio.currentTime = 0;
  return audio;
};

export function playNotificationSound(filePath) {
  const audio = createNotificationAudio(filePath);
  audio.play().catch((error) => {
    console.error("Audio play failed:", error);
  });
}

// Function to handle config object with isEnabled and audio properties
export function playNotificationFromConfig(config) {
  if (!config || !config.isEnabled || !config.audio) {
    return;
  }

  playNotificationSound(config.audio);
}

// Function with multiple fallback strategies for robust audio playback
export function playNotificationSoundRobust(filePath) {
  if (!filePath) {
    console.error("No file path provided for audio playback");
    return;
  }

  // Throttle notifications to prevent multiple rapid plays
  const now = Date.now();
  if (now - lastPlayTime < NOTIFICATION_THROTTLE_MS) {
    return;
  }
  lastPlayTime = now;

  // Stop any currently playing audio
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }

  const audio = createNotificationAudio(filePath);
  currentAudio = audio;
  audio.onended = () => {
    if (currentAudio === audio) currentAudio = null;
  };
  audio.onerror = () => {
    if (currentAudio === audio) currentAudio = null;
  };
  audio.play().catch((error) => {
    if (currentAudio === audio) currentAudio = null;
    console.error("Audio play failed:", error);
  });
}
